import axios from './_nestAxios'
import inveAxios from 'services/_inveAxios'


export const getAsSelectInve = (tipo, otrosFiltros) =>
  inveAxios.get('/tablas-comunes', {
    params: { tipo, tipoConsulta: 'select', filtros: otrosFiltros }
  })

export const getAsSelect = (tipo, otrosFiltros) =>
  axios.get('/tablas-comunes', {
    params: { tipo, tipoConsulta: 'select', filtros: otrosFiltros }
  })

export const obtenerxTipoAsSlim = tipo => axios.get('/tablas-comunes', { params: { tipo, tipoConsulta: 'slim' } })

export const getAsEdicion = id => axios.get(`/tablas-comunes/${id}`)

export const nuevo = data => axios.post('/tablas-comunes', data)

export const actualizarxId = (id, data) => axios.put(`/tablas-comunes/${id}`, data)

export const eliminarxId = id => axios.delete(`/tablas-comunes/${id}`)

export const descargarPlantilla = () =>
  axios.get('/tablas-comunes/descargar/plantilla', {
    responseType: 'blob'
  })

export const importarPlantilla = data => axios.post('/tablas-comunes/importar-plantilla', data)
